import { Component, ViewChild, inject } from "@angular/core";
import { AnlageDetailDto, AnlageLookupDto } from "src/app/web-api/web-api";
import { ICstGuiCommand } from "src/app/common-components/list-view/models";
import { CstNavigationService } from "src/app/services/cst-navigation.service";
import {
  CstRouteService,
  ICstRouteService,
} from "src/app/services/cst-route.service";
import { ActivatedRoute } from "@angular/router";
import { AnlageListComponent } from "src/app/anlage-api/components/list/anlage-list.component";
import { CstResponsivePopupService } from "src/app/common-components/resp-popup/services/resp-popup.service";
import {
  AnlageApiFaciliyUpdateDialogComponent,
  IAnlageApiFaciliyUpdateDialogData,
} from "src/app/anlage-api/dialogs/facility-update/facility-update.component";
import { tap } from "rxjs/operators";
import { PermissionService } from "src/app/services/permission.service";

@Component({
    selector: "app-infoportal-api-elevators-overview",
    templateUrl: "./elevators-overview.component.html",
    styleUrls: ["./elevators-overview.component.scss", "../../styles.scss"],
    standalone: false
})
export class InfoportalApiElevatorOverviewComponent {
  private _popService = inject(CstResponsivePopupService);
  private _navService = inject(CstNavigationService);
  private _perm = inject(PermissionService);

  @ViewChild(AnlageListComponent) list: AnlageListComponent;

  private _routeService: ICstRouteService<"update">;

  public actions: ICstGuiCommand<AnlageLookupDto>[] = [
    {
      label: $localize`:@@FacilityOverview_Facility_Edit:Edit`,
      icon: "edit",
      execute: (anlage) =>
        this._routeService.setQueryDialogType("update", {
          facilityID: anlage.anlageID,
        }),
      canExecute: (anlage) => this._canFacilityUpdate(anlage.anlageID),
    },
  ];

  public entryClickCommand: ICstGuiCommand<AnlageLookupDto> = {
    execute: (anlage) =>
      this._navService.navigateTo_Infoportal_Elevators(
        anlage.anlageID,
        undefined
      ),
  };

  constructor() {
    const route = inject(ActivatedRoute);
    const routeService = inject<CstRouteService<"update">>(CstRouteService);

    this._routeService = routeService.create(route);
    this._routeService.registerDialogTypeCallbacks({
      update: (params) => this._openFacilityUpdateDialog(params.facilityID),
    });
  }

  private _openFacilityUpdateDialog(facilityID: number) {
    if (!this._canFacilityUpdate(facilityID)) {
      this._routeService.resetQueryDialogType();
      return;
    }
    const ref = this._popService.open<
      AnlageApiFaciliyUpdateDialogComponent,
      IAnlageApiFaciliyUpdateDialogData,
      AnlageDetailDto
    >(AnlageApiFaciliyUpdateDialogComponent, {
      data: { id: facilityID },
    });
    return ref.afterClosed().pipe(
      tap((result) => {
        if (!result || !this.list) {
          return;
        }
        this.list.dataSource.refresh();
      })
    );
  }
  private _canFacilityUpdate(_facilityID: number) {
    return this._perm.UserCan_Anlage_FacilityUpdate;
  }
}
